import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/recursos/migracion-shopify-plus")({
  beforeLoad: () => {
    throw redirect({
      href: "/es/recursos/playbook-replatforming-shopify",
      statusCode: 301,
    });
  },
});
